<template>
    <div class="service">
        <h1>Service</h1>
        <p>Ops level services.</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Service",
});
</script>
